export const blockIconsNavigationArrowDownward = (
	<span className='material-symbols-outlined'>arrow_downward</span>
);
